import React from 'react';
import { useChatStore } from '../../stores/chatStore';

const badgeStyle: React.CSSProperties = {
  position: 'fixed',
  top: '48px',
  left: '20px',
  zIndex: 250,
  fontSize: '12px',
  lineHeight: 1.2,
  background: 'rgba(0,0,0,0.6)',
  color: '#fff',
  padding: '6px 8px',
  borderRadius: '6px',
  backdropFilter: 'saturate(120%) blur(4px)'
};

export const StreamRequestIdBadge: React.FC = () => {
  const current = useChatStore((s) => s.currentStream);

  if (!current) return null;
  const { requestId, conversationRef, status } = current;
  const short = requestId?.slice(0, 16);

  return (
    <div style={badgeStyle} title={`RequestId: ${requestId}  Conversation: ${conversationRef}`}>
      <div><strong>Stream:</strong> {status}</div>
      {short && <div><strong>ReqID:</strong> {short}{requestId.length > 16 ? '…' : ''}</div>}
      {conversationRef && <div><strong>Conv:</strong> {String(conversationRef).slice(0, 10)}…</div>}
    </div>
  );
};

export default StreamRequestIdBadge;

